import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import "./CreateTask.css";
import { useState, useEffect } from "react";
import Swal from "sweetalert2";
import Topbar from "../Topbar/Topbar";
import { FiUpload } from "react-icons/fi";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useRef } from "react";
import { useLocation } from "react-router-dom";
import MessageBox from "../MessageBox/MessageBox";
import { useSelector } from "react-redux";


export default function View_CreateTask() {

  const apiUrl = process.env.REACT_APP_API_BASE_URL;
  const [selectedStatus, setSelectedStatus] = useState("");
   const [pageRefId, setpageRefId] = useState("")
  
    const [isOpenConverted, setIsOpenConverted] = useState(false);
     const [showMessageBox, setShowMessageBox] = useState(false);
        const [messageData, setMessageData] = useState(null);
          const staffName = useSelector((state) => state.staffname);
          const Id = useSelector((state) => state.id);
        

  const locate = useLocation();

  // let [taskAssignDate, setTaskAssignDate] = useState("");

  // let [taskDeadline, setTaskDeadline] = useState("");

  const [selectedFile, setSelectedFile] = useState(null);


  const [selectedNames, setSelectedNames] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const [taskData, setTaskData] = useState([])


  


  useEffect(() => {
    if (locate.state?.id) {
      axios
        .post(apiUrl + "getdata-enquiry", {
          id: locate.state.id,
        })
        .then((res) => {
          setTaskData(res.data.message);
          setpageRefId(res.data.message._id)
        });
    }
  }, [locate.state?.id]);

  const handleInputChange = (field, value) => {
    setTaskData(prev => ({
      ...prev,
      [field]: value
    }));
  };
  const names = [
    'Saravanan',
    'Ravikumar',
    'Sathishkumar',
    'Venkatesh'
  ];

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const handleCheckboxChange = (name) => {
    setSelectedNames(prev =>
      prev.includes(name)
        ? prev.filter(n => n !== name)
        : [...prev, name]
    );

  };

  const displayText = selectedNames.length > 0
    ? selectedNames.join(', ')
    : 'Select names';

  //Date/Time


  const navi = useNavigate();

  const handleFileChange = (event) => {
    setSelectedFile(event.target.files[0]);
  };

  function gototaskPage() {
    navi("/task");
  }

  const [IsOpenTask, setIsOpenTask] = useState(false);
  const [IsUpdateHistory, setIsUpdateHistory] = useState(false);
  const [IsShowUploadTask, setIsShowUploadTask] = useState(false);
  const [IsDotBox, setIsDotBox] = useState(false);

  function showOpenTask() {
    setIsOpenTask(true);

  }

  function showUploadTask() {
    setIsOpenTask(false)

    setIsUpdateHistory(true);
  }

  const handleSubmitAssignTask = async (e) => {
    e.preventDefault();


    Swal.fire({
      title: "Do you want to save the Task Assign Details?",
      showCancelButton: true,
      confirmButtonText: "Save",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {

          const datas = { ...taskData, assignedTo: selectedNames }

          const response = await axios.post(
            apiUrl +"add-assign-task",
            datas,
            { headers: { "Content-Type": "application/json" } }
          );

          Swal.fire({
            title: "Customer Details Added Successfully!",
            icon: "success",
          }).then(() => {
            // navigate("/enquiry");
          });
        } catch (error) {
          console.log("Error submitting data:", error.response?.data || error.message);
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: error.response?.data?.message || "Something went wrong!",
          });
        }
      }
    });
  };


  const getStatusColor = (status) => {
  switch (status) {
    case "Hold":
      return "#FFD700"; // Gold
    case "Completed":
      return "#28a745"; // Green
    default:
      return "#ccc"; // Default gray
  }
};




const handleChange = (e) => {
  const { name, value } = e.target;

  setTaskData((prev) => ({
    ...prev,
    [name]: value,
  }));

  // Check if the leadStatus is being changed
  if (name === "leadStatus") {
    setSelectedStatus(value);  
    setIsOpenConverted(true);       // 👈 trigger popup
    // 👈 store selected status
  }
};
  
  const handleStatusClick = (status) => {
    setIsOpenConverted(true);
    console.log("Selected Status:", status);
  };



const handleUpdateTask = () => {
  if (!taskData._id) {
    console.log("ID not found in taskData");
    return;
  }

  Swal.fire({
    title: "Are you sure?",
    text: "Do you want to update the task details?",
    icon: "question",
    showCancelButton: true,
    confirmButtonText: "Yes",
    cancelButtonText: "Cancel",
  }).then((result) => {
    if (result.isConfirmed) {
      const updateData = {
        taskName: taskData.taskName,
        taskType: taskData.taskType,
        taskPriority: taskData.taskPriority,
        description: taskData.description,
        assignedTo: taskData.assignedTo,
        deadline: taskData.deadline,
        taskStatus: taskData.taskStatus,
      };

      let colorCode = "#fbdc6e"; // default for "Open"

switch (taskData.taskStatus) {
  case "Open":
    colorCode = "#fbdc6e";
    break;
  case "No Response":
    colorCode = "#ffa5ee"; // light pink
    break;
  case "Converted":
    colorCode = " #2c693a"; // light green
    break;
  case "Hold":
    colorCode = "#ffa770"; // orange
    break;
  case "Cancelled":
    colorCode = "#f07c7c"; // red
    break;
  case "Not Feasible":
    colorCode = "#2e5caf"; // sky blue
    break;
  default:
    colorCode = "#cccccc"; // gray fallback
}



      axios
        .put(apiUrl + "update-task", { id: taskData._id, updateData })
        .then(async (res) => {
          if (res.data.message === "Task updated successfully") {
            setTaskData(res.data.data);

            // === Message Box Logic ===
            const now = new Date();
            const date = now.toLocaleDateString();
            const time = now.toLocaleTimeString();

            const formData = new FormData();
            formData.append("pageRefId", taskData._id);
            formData.append("page", "Task");
            formData.append("colorCode",colorCode); // Yellow
            formData.append("description", taskData.description || "Task updated");
            formData.append("staffPic", "");
            if (selectedFile) {
              formData.append("image", selectedFile);
            }
            formData.append("updatesHistory[staff][name]", staffName);
            formData.append("updatesHistory[staff][id]", Id);
            formData.append("updatesHistory[status]", taskData.taskStatus);

            await axios.post(apiUrl + "add-message", formData, {
              headers: { "Content-Type": "multipart/form-data" },
            });

            const msgRes = await axios.get(`${apiUrl}messages/${taskData._id}`);
            setMessageData(msgRes.data.data);
            setShowMessageBox(true);


              if (taskData.taskStatus === "Completed") {
                        const workDetailPayload = {
                          type: "task", // You can change this to "complaint" or "installation" as needed
                          pageRefId: taskData._id,
                          staffId: Id,
                          staffName: staffName,
                          actionStatus: "complete",
                          // Optional fields:
                          // bikeType: ...,
                          // cableUsed: ...,
                          // location: { latitude: ..., longitude: ... },
                        };
            
                        try {
                          await axios.post(apiUrl + "work-detail", workDetailPayload, {
                            headers: { "Content-Type": "application/json" },
                          });
                          console.log("Work detail logged successfully.");
                        } catch (err) {
                          console.error("Work detail logging failed:", err.response?.data || err.message);
                        }
                      }

            Swal.fire("Success", "Task details updated successfully!", "success");
          } else {
            throw new Error("Update failed");
          }
        })
        .catch((err) => {
          console.error("Error updating task:", err);
          Swal.fire("Error", "Failed to update task details.", "error");
        });
    } else {
      Swal.fire("Cancelled", "Task update cancelled.", "info");
    }
  });
};


  useEffect(() => {
  const fetchMessages = async () => {
    try {
      const response = await axios.get(`${apiUrl}messages/${pageRefId}`);

      if (response.status === 200 && Array.isArray(response.data.data)) {
        setMessageData(response.data.data); // ✅ Only the array!
      } else {
        console.error("Unexpected response structure:", response);
        setMessageData([]); // fallback to empty array
      }
    } catch (error) {
      console.error("Error fetching messages:", error);
      setMessageData([]); // fallback to empty array
    }
  }; 

  fetchMessages();
}, [apiUrl, pageRefId]);


  console.log(taskData)


   const handleLeadChange = (e) => {
    const { name, value } = e.target;
    setTaskData(prevState => ({
      ...prevState,
      taskData: {
        ...prevState.taskData,
        [name]: value
      }
    }));
  };

  function formatDate(dateString) {
    const date = new Date(dateString);

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based
    const year = date.getFullYear();

    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12;

    return `${day}-${month}-${year} / ${hours}:${minutes} ${ampm}`;
  }


  return (
    <>
      <Topbar />
      <Container className="mt-1">
        <Row className="ct-mainhead">
          <Col>
            <h3>My Task</h3>
          </Col>

          <Col className="text-end">
            <button
              className="bluetask-btn px-4 text-white "
              value="submit"
              type="submit"
              // onClick={gototaskPage}
onClick={(e) => {
  e.preventDefault();
  handleUpdateTask();
}}            >
              Submit
            </button>
          </Col>
        </Row>
        <Row className="task-create-container">
          <div className="task-shadow">
            <form>
              {/* <h6 className="create-task-head">Create Task</h6> */}
              <div className="create-task-head-1">
                <Row className="g-5">
                  <Col sm={12} md={6}>
                    <Row>
                      <Col sm={12} md={6} className="text-start">
                        <lable sm={12} className="rowdown ">
                          Task Name
                        </lable>
                        <br />
                        <input
                          sm={12}
                          type="text"
                          required
                          onChange={(e) => handleInputChange('taskName', e.target.value)}
                          name="taskName"
                          className="form-input"
                          placeholder="Enter Task Name"
                          value={taskData.taskName}
                          readOnly
                        />
                      </Col>

                      <Col sm={12} md={6} className="text-start">
                        <lable className="rowdown">Assign Date/Time</lable>
                        <br />
                        <input
                          type="datetime-local"
                          value={taskData.assignDateTime}
readOnly
                          className="form-input"
                          onChange={(e) => handleInputChange('assignDateTime', e.target.value)}

                        />
                      </Col>
                    </Row>
                    <Row className="mt-4">
                      <Col xs={12} md={6} className="text-start">
                        <lable>
                          Task Asign To

                        </lable>
                        <br />
                        {/* <select
                                                                                                          onChange={(e) => setTaskAssignTo(e.target.value)}
                                                                                                          class="dropbtn form-input-select overlay2"
                                                                                                      >
                                                                                                          <option value="">Select</option>
                                                                                                          <option
                                                                                                              className="onlineback"
                                              
                                                                                                              value="Online"
                                                                                                          >
                                                                                                              Online
                                                                                                          </option>
                                                                                                          <option className="offlineback" value="Offline">
                                                                                                              Offline
                                                                                                          </option>
                                                                                                      </select> */}

                          <input
                        readOnly
  value={taskData.assignedTo?.map(person => person.staffName).join(", ")}
                          sm={12}
                          // type="date"
                          required
                          className="form-input-task"
                          placeholder=""
                        />


                      </Col>

                      <Col xs={12} md={6} className="text-start">
                        <lable>Approve Person  </lable>
                        <br />
                           <input
                        readOnly
  value={taskData.approvePerson?.map(person => person.staffName).join(", ")}
                          sm={12}
                          // type="date"
                          required
                          className="form-input-task"
                          placeholder=""
                        />

                      </Col>


                      <Col xs={12} md={12} className="text-start mt-3">
                        <lable>Description</lable>
                        <br />
                        <textarea
                          type="text"
                          onChange={(e) => handleInputChange('description', e.target.value)}
                          style={{
                            textTransform: "capitalize",
                            resize: "none",

                          }}
                          className="form-input inputfield-assign "
                          placeholder="Enter Notes "
                          readOnly
                                                      value={taskData.description}


                        />

                      </Col>
                    </Row>
                  </Col>
                  <Col sm={12} md={6}>
                    <Row>
                      {/* <Col sm={12} md={6} className="text-start">
                        <lable sm={12} className="rowdown ">
                          Task Type
                        </lable>
                        <br />

                           <input
                        readOnly
  value={taskData.taskType}
                          sm={12}
                          // type="date"
                          required
                          className="form-input-task"
                          placeholder=""
                        />
                       
                      </Col> */}

                      <Col sm={12} md={6} className="text-start">
                        <lable className="rowdown">Task Priority</lable>
                        <br />
                          <input
                        readOnly
  value={taskData.taskPriority}
                          sm={12}
                          // type="date"
                          required
                          className="form-input-task"
                          placeholder=""
                        />
                      </Col>
                       <Col sm={12} md={6} className="text-start">
                        <lable sm={12} className="rowdown ">
                          Deadline Date/Time
                        </lable>
                        <br />
                        <input
                          type="local-time"
                          onChange={(e) => handleInputChange('deadline', e.target.value)}
                          className="form-input overlay2"
                          placeholder=""
                          value={formatDate(taskData.deadline)}
                          readOnly
                        />
                      </Col>
                    </Row>
                    <br />
                    <Row>
                     

                      {/* <Col xs={12} md={6} className="text-start">
                        <lable>Time</lable>
                        <br />
                        <input
                        value={taskData.time}
                          type="text"
                          onChange={(e) => handleInputChange('time', e.target.value)}
                          className="form-input overlay2"
                          placeholder=""
                          readOnly
                        />
                      </Col> */}

                      {/* <Col sm={12} md={6} className="text-start">
                        <lable className="rowdown">Task Status</lable>
                        <br />

                        <input
                          sm={12}
                          type="string"
                          onChange={(e) => setTaskDeadline(e.target.value)}
                          className="openTask-form"
                          placeholder="Open"
                          // onClick={() => setIsOpenTask(true)}
                          onClick={showOpenTask}
                        />

                        {IsOpenTask && (
                          <div className="overlay1-open">
                            <div className="modal1-open">
                              <Container>
                                <button
                                  className="close-btn1"
                                  onClick={() => setIsOpenTask(false)}
                                >
                                  <span style={{ fontSize: "20px" }}>
                                    &times;
                                  </span>
                                </button>

                                <div className="open-button">
                                  <h5>Open</h5>
                                </div>

                                <textarea
                                  style={{
                                    textTransform: "capitalize",
                                    resize: "none",
                                  }}
                                  placeholder="Enter Description"
                                  className="open-textbox"
                                />
                                <div className="upload-section">
                                  <label className="upload-btn">
                                    <FiUpload className="upload-icon" />
                                    Upload Image
                                    <input
                                      type="file"
                                      accept="image/*"
                                      onChange={handleFileChange}
                                      hidden
                                    />
                                  </label>
                                  {selectedFile && (
                                    <p className="file-name">
                                      {selectedFile.name}
                                    </p>
                                  )}
                                </div>

                                <Row>
                                  <Col className="uploadbtn-install">
                                    <button
                                      type="button"
                                      className="blue-btn"
                                      onClick={showUploadTask}
                                    >
                                      Upload
                                    </button>
                                  </Col>
                                </Row>
                              </Container>
                            </div>
                          </div>
                        )}
                      </Col> */}




                      {/* <Col xs={12} md={6} className="text-start">
                        <lable>Task Status  </lable>
                        <br />
                        

                         <select
                          onChange={(e) => handleInputChange('taskStatus', e.target.value)}
                          class="dropbtn form-input-select overlay2"
                          value={taskData.taskStatus}
                        >
                          <option value="">Select</option>
                          <option

                            value="Hold On"
                          >
                            Hold On
                          </option>
                          
                          <option value="Completed">
                            Completed
                          </option>
                         
                        </select>

                      </Col> */}

                      {/* <Col xs={12} md={6} className="text-start">
                                          <lable>Lead Status</lable>
                                          <br />
                                          <input style={{ backgroundColor: "#fbdc6e", color: "rgb(94, 94, 14)" }}
                                            type="button"
                                               
                                            // onChange={handleChange} 
                                            name="enquiryLeadStatus" 
                      
                                            onClick={() => setIsOpenConverted(true)}
                                            className="form-input converted-form"
                                            
                                            value={taskData.taskStatus || ""}
                      
                                          />
                      
                      
                      
                                          {isOpenConverted && (
                                            <div className="overlay1-converted">
                                              <div className="modal1-converted">
                                                <Container>
                                                  <button
                                                    className="close-btn1"
                                                    onClick={() => setIsOpenConverted(false)}
                                                  >
                                                    <span style={{ fontSize: "20px" }}>
                                                      {" "}
                                                      &times;{" "}
                                                    </span>
                                                  </button>
                      
                                                  <div className="open-button border">
                                                    <h5>{taskData.taskStatus}</h5>
                                                  </div>
                      
                                                  <textarea
                                                    style={{
                                                      textTransform: "capitalize",
                                                      resize: "none",
                                                    }}
                      
                                                    placeholder="Enter Notes"
                                                    className="converted-textbox"
                                                    name="enquirynotes"
                                                    // onChange={handleLeadChange}
                                                    // value={enquiryDetails.enquiryleadStatus.enquirynotes}     
                      
                      
                      
                                                  />
                                                  <div className="upload-section">
                                                    <label className="upload-btn">
                                                      <FiUpload className="upload-icon" />
                                                      Upload Image
                                                      <input
                                                        type="file"
                                                        accept="image/*"
                                                        // onChange={handleFileChange}
                      
                      
                                                        hidden
                                                      />
                                                    </label>
                                                    {selectedFile && (
                                                      <p className="file-name">{selectedFile.name}</p>
                                                    )}
                                                  </div>
                      
                                                  <Row>
                                                    <Col className="date-update-textbox">
                                                      <label>Next Follow Up Date</label>
                                                      <br />
                                                      <input
                                                        type="date"
                                                        className="field form-input"
                                                        // value={enquiryDetails.enquiryleadStatus.enquiryLeadStatusnextFollowUpDate}     
                                                        // onChange={handleLeadChange} 
                                                        name="enquirynextFollowUpDate" 
                      
                                                      />
                                                    </Col>
                                                    <Col className="uploadbtn-install">
                                                      <button type="button" className="blue-btn"
                                                        onClick={() => setIsOpenConverted(false)}>
                                                        Upload
                                                      </button>
                                                    </Col>
                                                  </Row>
                                                </Container>
                                              </div>
                                            </div>
                                          )}
                                        </Col> */}

                                          <Col xs={12} md={6} className="text-start ">
                            <lable>Task Status</lable>
                            <br />
                           


<select
  className={`lead-status-select dropbtn form-input-select lead-${taskData.taskStatus?.replace(/\s/g, '-').toLowerCase()}`}
  name="leadStatus"
  value={taskData.taskStatus || ""}
  style={{
    backgroundColor: taskData.taskStatus === "Progress" ? "#c5c3c3ff" : "", // grey for Progress
    color: taskData.taskStatus === "Progress" ? "#333" : "",
  }}
  onChange={handleChange}
>
  {/* If status is not in options (like Progress), show it as hidden default */}
  {!["Hold", "Completed"].includes(taskData.taskStatus) && taskData.taskStatus && (
    <option
      value={taskData.taskStatus}
      hidden
         style={{ background: "#6c757d" }}

      // optional grey text
    >
      {taskData.taskStatus}
    </option>
  )}

  <option style={{background:"#ffa770"}} value="Hold">Hold</option>
  <option  style={{background:"#b0e9bd"}}value="Completed">Completed</option>
</select>



        
                            {isOpenConverted && (
                              <div className="overlay1-converted">
                                <div className="modal1-converted">
                                  <Container>
                                    <button
                                      className="close-btn1"
                                      onClick={() => setIsOpenConverted(false)}
                                    >
                                      <span style={{ fontSize: "20px" }}>
                                        {" "}
                                        &times;{" "}
                                      </span>
                                    </button>
        
                                    <div className="open-button border"  style={{ backgroundColor: getStatusColor(selectedStatus), }}>
                                      <h5>{selectedStatus}</h5>
                                    </div>
        
                                    <textarea
                                      style={{
                                        textTransform: "capitalize",
                                        resize: "none",
                                      }}
        
                                      placeholder="Enter Notes"
                                      className="converted-textbox"
                                      name="enquirynotes"
                                      // onChange={handleLeadChange}
                                      // value={enquiryDetails.enquiryleadStatus.enquirynotes}     
        
        
        
                                    />
                                    <div className="upload-section">
                                      <label className="upload-btn">
                                        <FiUpload className="upload-icon" />
                                        Upload Image
                                        <input
                                          type="file"
                                          accept="image/*"
                                          onChange={handleFileChange}
        
        
                                          hidden
                                        />
                                      </label>
                                      {selectedFile && (
                                        <p className="file-name">{selectedFile.name}</p>
                                      )}
                                    </div>
        
                                    <Row>
                                      {/* <Col className="date-update-textbox">
                                        <label>Next Follow Up Date</label>
                                        <br />
                                        <input
                                          type="date"
                                          className="field form-input"
                                          // value={enquiryDetails.enquiryleadStatus.enquiryLeadStatusnextFollowUpDate}     
                                          // onChange={handleLeadChange} 
                                          name="enquiryLeadStatusnextFollowUpDate" 
        
                                        />
                                      </Col> */}
                                      <Col className="uploadbtn-install">
                                        <button type="button" className="blue-btn"
                                          // onClick={() => setIsOpenConverted(false)}
                                           onClick={() => {
    setTaskData(prev => ({ ...prev, taskStatus: selectedStatus }));
    setIsOpenConverted(false);
  }}
                                          >
                                          Upload
                                        </button>
                                      </Col>
                                    </Row>
                                  </Container>
                                </div>
                              </div>
                            )}
                          </Col>


                                        
                    </Row>
                  </Col>
                </Row>

              </div>
            </form>
          </div>
        </Row>
       <Row className="container ms-3 me-5">
     <Col md={6} sm={12}>
       <div>
         {Array.isArray(messageData) && messageData.length > 0 ? (
           messageData.map((msg) => (
             <MessageBox key={msg._id} message={msg} />
           ))
         ) : (
           <div className="text-muted">No messages available.</div>
         )}
       </div>
     </Col>
   
     <Col md={6} sm={12}>
       <div className="compact-updates-history">
         <div className="compact-updates-header">Updates History</div>
         {Array.isArray(messageData) && messageData.length > 0 ? (
           messageData.map((data, index) => (
             <div className="compact-update text-center" key={index}>
               <div className="compact-update-date text-center">
                 {data.updatesHistory.date ? (
                   new Date(data.updatesHistory.date).toLocaleDateString("en-GB") +
                   " - " +
                   new Date(data.updatesHistory.date)
                     .toLocaleTimeString("en-US", {
                       hour: "2-digit",
                       minute: "2-digit",
                       hour12: true,
                     })
                 ) : (
                   "No date"
                 )}
               </div>
   
               <div className="compact-update-user text-center">
                 {data.updatesHistory?.staff?.name || "Unknown"}
               </div>
   
               <div
                 className="compact-update-status text-center"
                 style={{ color: data.colorCode || "#000000" }}
               >
                 {data.updatesHistory?.status || "No Status"}
               </div>
             </div>
           ))
         ) : (
           <div className="text-muted text-center">No update history available.</div>
         )}
       </div>
     </Col>
   </Row>
      </Container>
    </>
  );
}
